"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.preventDefault = preventDefault;
exports.stopPropagation = stopPropagation;

/**
 * @module ol/events/Event
 */

/**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */
var BaseEvent =
/** @class */
function () {
  /**
   * @param {string} type Type.
   */
  function BaseEvent(type) {
    /**
     * @type {boolean}
     */
    this.propagationStopped;
    /**
     * @type {boolean}
     */

    this.defaultPrevented;
    /**
     * The event type.
     * @type {string}
     * @api
     */

    this.type = type;
    /**
     * The event target.
     * @type {Object}
     * @api
     */

    this.target = null;
  }
  /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */


  BaseEvent.prototype.preventDefault = function () {
    this.defaultPrevented = true;
  };
  /**
   * Stop event propagation.
   * @api
   */


  BaseEvent.prototype.stopPropagation = function () {
    this.propagationStopped = true;
  };

  return BaseEvent;
}();
/**
 * @param {Event|import("./Event.js").default} evt Event
 */


function stopPropagation(evt) {
  evt.stopPropagation();
}
/**
 * @param {Event|import("./Event.js").default} evt Event
 */


function preventDefault(evt) {
  evt.preventDefault();
}

var _default = BaseEvent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7Ozs7QUFJQTs7Ozs7Ozs7OztBQVVBO0FBQUE7QUFBQTtFQUNFOzs7RUFHQSxtQkFBWUEsSUFBWixFQUFnQjtJQUNkOzs7SUFHQSxLQUFLQyxrQkFBTDtJQUVBOzs7O0lBR0EsS0FBS0MsZ0JBQUw7SUFFQTs7Ozs7O0lBS0EsS0FBS0YsSUFBTCxHQUFZQSxJQUFaO0lBRUE7Ozs7OztJQUtBLEtBQUtHLE1BQUwsR0FBYyxJQUFkO0VBQ0Q7RUFFRDs7Ozs7OztFQUtBQztJQUNFLEtBQUtGLGdCQUFMLEdBQXdCLElBQXhCO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7RUFJQUU7SUFDRSxLQUFLSCxrQkFBTCxHQUEwQixJQUExQjtFQUNELENBRkQ7O0VBR0Y7QUFBQyxDQTlDRDtBQWdEQTs7Ozs7QUFHTSxTQUFVSSxlQUFWLENBQTBCQyxHQUExQixFQUE2QjtFQUNqQ0EsR0FBRyxDQUFDRCxlQUFKO0FBQ0Q7QUFFRDs7Ozs7QUFHTSxTQUFVRSxjQUFWLENBQXlCRCxHQUF6QixFQUE0QjtFQUNoQ0EsR0FBRyxDQUFDQyxjQUFKO0FBQ0Q7O2VBRWNILFMiLCJuYW1lcyI6WyJ0eXBlIiwicHJvcGFnYXRpb25TdG9wcGVkIiwiZGVmYXVsdFByZXZlbnRlZCIsInRhcmdldCIsIkJhc2VFdmVudCIsInN0b3BQcm9wYWdhdGlvbiIsImV2dCIsInByZXZlbnREZWZhdWx0Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ldmVudHMvRXZlbnQuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=